import React, { useEffect, useState } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSelectedId, setSelectedId } from "./modalSlice";
import { selectUserById } from "../users/usersSlice";
import SocialLogo from "../../components/SocialLogo/";

const imgPath = "https://www.digitalavenue.org/profiles/";
const Copy = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"
    />
  </svg>
);
const CopyChecked = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="h-5 w-5"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"
    />
  </svg>
);

const HireMeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-6 h-6 flex-shrink mr-2"
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M9 12l2 2 4-4M7.835 4.697a3.42 3.42 0 001.946-.806 3.42 3.42 0 014.438 0 3.42 3.42 0 001.946.806 3.42 3.42 0 013.138 3.138 3.42 3.42 0 00.806 1.946 3.42 3.42 0 010 4.438 3.42 3.42 0 00-.806 1.946 3.42 3.42 0 01-3.138 3.138 3.42 3.42 0 00-1.946.806 3.42 3.42 0 01-4.438 0 3.42 3.42 0 00-1.946-.806 3.42 3.42 0 01-3.138-3.138 3.42 3.42 0 00-.806-1.946 3.42 3.42 0 010-4.438 3.42 3.42 0 00.806-1.946 3.42 3.42 0 013.138-3.138z"
    />
  </svg>
);

const getImgUrl = (profile) => {
  if (profile.photo) {
    return imgPath + profile.photo;
  }
  if (profile.Gender === "Male") {
    return "https://bootdey.com/img/Content/avatar/avatar1.png";
  }
  if (profile.Gender === "Female") {
    return "https://bootdey.com/img/Content/avatar/avatar8.png";
  }
  return "https://bootdey.com/img/Content/avatar/avatar1.png";
};

const ModalPage = () => {
  const [open, setOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();
  const selectedId = useSelector(getSelectedId);
  const closeModal = () => {
    setOpen(false);
    setTimeout(() => {
      dispatch(setSelectedId(null));
    }, 500);
  };

  const profile = useSelector((state) =>
    selectUserById(state, Number(selectedId))
  );

  useEffect(() => {
    setOpen(!!selectedId);
  }, [selectedId]);

  const copyEmail = (email) => {
    navigator.clipboard.writeText(email);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 1000);
  };

  const getExperience = (experience) => {
    if (!experience) return;
    if (isNaN(experience)) return <span>experience</span>;

    experience = Number(experience);
    return (
      <span>
        {experience} year{experience > 1 && "s"}
      </span>
    );
  };
  if (!profile) return <></>;

  return (
    <Transition appear show={open} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={closeModal}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-25" />
        </Transition.Child>

        <div className="fixed inset-0 overflow-y-auto ">
          <div className="flex min-h-full items-center justify-center p-4 text-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <Dialog.Panel className="w-full max-w-screen-lg transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all relative pb-12">
                <button
                  className="absolute top-0 right-0 rounded-all m-2 w-6 text-center"
                  onClick={closeModal}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-6 w-6"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    strokeWidth={2}
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  </svg>
                </button>
                <div className="grid grid-cols-1 md:grid-cols-7 md:gap-7">
                  <div className="col-span-3 mb-5 md:!mb-0">
                    <div className="relative overflow-hidden h-96 md:h-full max-h-[484px] rounded-md">
                      <img
                        src={getImgUrl(profile)}
                        alt={profile.name}
                        className=" object-cover h-full w-full"
                        loading="lazy"
                      />
                    </div>
                  </div>
                  <div className="col-span-4">
                    <h2 className="text-2xl text-gray-700">{profile.Name}</h2>
                    <div className="my-2">
                      <hr className="border-slate-100" />
                    </div>
                    <div className="text-gray-800 text-md !mt-4">
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">Sector</div>
                        <div className="col-span-2 md:col-span-9">
                          {profile.Sector}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">Education</div>
                        <div className="col-span-2 md:col-span-9">
                          {profile.Level_of_Education}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">Specialty</div>
                        <div className="col-span-2 md:col-span-9">
                          {profile.Specialty}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">
                          Experience
                        </div>
                        <div className="col-span-2 md:col-span-9">
                          {getExperience(profile.Years_of_Experience)}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">Gender</div>
                        <div className="col-span-2 md:col-span-9">
                          {profile.Gender}
                        </div>
                      </div>
                      <div className="grid grid-cols-3 md:grid-cols-12 gap-5 p-2 hover:bg-indigo-50/80 transition-all duration-300">
                        <div className="md:col-span-3 font-bold">City</div>
                        <div className="col-span-2 md:col-span-9">
                          {profile.Location}
                        </div>
                      </div>
                    </div>
                    <ul className="mt-3 list-none hidden">
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>Sector:</b> {profile.Sector}
                      </li>
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>Education:</b> {profile.Level_of_Education}
                      </li>
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>Specialty:</b> {profile.Specialty}
                      </li>
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>Years of Experience:</b>{" "}
                        {profile.Years_of_Experience}
                      </li>
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>Gender:</b> {profile.Gender}
                      </li>
                      <li className="mt-3 pt-0 text-gray-800 text-md list-none">
                        <b>City:</b> {profile.Location}
                      </li>
                    </ul>
                    <h2 className="mt-3 text-xl font-bold pl-2">Profile on:</h2>
                    <div className="flex justify-start mt-2 items-start min-h-[2rem]">
                      {profile.socialNetworks.map((social, i) => (
                        <SocialLogo url={social} key={i} size={40} />
                      ))}
                    </div>
                    <div className="my-2">
                      <hr className="border-slate-100" />
                    </div>
                    <div className="md:flex justify-start items-center mt-4 pl-2">
                      <a
                        href={`mailto:${profile.Email}`}
                        className="flex transition-all duration-300 justify-center rounded-md border !border-indigo-100 bg-indigo-100 px-4 py-2 text-lg font-medium text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                      >
                        <span className="pt-0.5">
                          <HireMeIcon />
                        </span>
                        <span>Hire Me! </span>&nbsp;
                      </a>
                      <div className="flex grow justify-start items-center">
                        <button className="md:ml-2 cursor-auto grow rounded-md border !border-slate-100 bg-white rounded-tr-none rounded-br-none -mr-2 !px-0 py-2 text-sm text-blue-900 ">
                          {profile.Email}
                        </button>
                        <button
                          onClick={() => copyEmail(profile.Email)}
                          className="transition-all duration-300 inline-flex justify-center rounded-md border !border-slate-100 border-l-0 bg-gray-50 rounded-bl-none rounded-tl-none mr-0 px-4 py-2 text-lg text-blue-900 hover:bg-blue-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-2"
                        >
                          {copied ? (
                            <>
                              <CopyChecked />{" "}
                              <small className="text-sm inline-block align-middle pt-0.5">
                                Copied!
                              </small>
                            </>
                          ) : (
                            <Copy />
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};

export default ModalPage;
